import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AutocompleteEditorComponent } from './autocomplete-editor.component';

@NgModule({
  imports: [CommonModule, FormsModule, MatInputModule, MatAutocompleteModule, ReactiveFormsModule, MatTooltipModule],
  declarations: [AutocompleteEditorComponent],
  entryComponents: [AutocompleteEditorComponent],
  exports: [AutocompleteEditorComponent]
})
export class AutocompleteEditorModule { }
